<template>
  <b-modal id="delete-managers-link-question-modal" :modal-class="`adp-modal`" :body-class="`adp-modal-body`"
           :header-class="`adp-modal-header`" :footer-class="`adp-modal-footer d-flex justify-content-center`">
    <template #modal-title>
      <h5 class="modal-title adp-h2 adp-h2__modal">
        {{ managerType === 'managers' ? $t('admin.delete_manager_link_question') : $t('admin.delete_fmanager_link_question') }}
      </h5>
    </template>
    <div class="adp-p adp-p__grey">
      {{ managerType === 'managers' ? $t('role.manager') : $t('admin.fmanager') }}: {{ managerData.managerFio }} <br>
      {{ $t('role.employee') }}: {{ managerData.subordinateName }} <br>
    </div>
    <template #modal-header-close>
      <span aria-hidden="true"><img src="/images/cross.svg" alt=""></span>
    </template>
    <template #modal-footer>
      <button class="btn btn-primary adp-btn adp-btn__large"
              style="margin-left: 235px; padding: 0 42px" @click="deleteManager()">
        {{ $t('modal.delete') }}
      </button>
      <button class="btn btn-primary adp-btn adp-btn__large"
              style="margin-left: auto; padding: 0 42px; background-color: #8D8F92" @click="cancel()">
        {{ $t('modal.cancel') }}
      </button>
    </template>
  </b-modal>
</template>

<script>
import api from "../../api";

export default {
  name: "DeleteManagersLinkQuestionModal",
  props: {
    managerData: {
      type: Object,
      required: true
    },
    managerType: {
      type: String,
      required: true,
    }
  },
  methods: {
    cancel() {
      this.$bvModal.hide('delete-managers-link-question-modal');
    },
    async deleteManager() {
      const data = {
        'subordinate': this.managerData.subordinate,
        'manager': this.managerData.manager,
      }

      if (this.managerType === 'managers') await api.deleteManagerLink(data);
      if (this.managerType === 'functional_managers') await api.deleteFunctionalManagerLink(data);

      this.$bvModal.hide('delete-managers-link-question-modal');
      this.$emit('managers-link-deleted');
    }
  }
}
</script>

<style scoped>

</style>
